import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { ApiRoutes } from "../configuration/apiRoutes";
import { SettingGroupType } from "../models/SettingGroupType";
import { SystemConfigGroupParametersRequest } from "../models/SystemConfigGroupParametersRequest";
import { SystemConfigParameterDto } from "../models/SystemConfigParameterDto";

export const getSystemConfigs = createAsyncThunk(
    "systemConfigs/getParams",
    async (params: SystemConfigGroupParametersRequest) => {
        const response = await axios.get<SystemConfigParameterDto[]>(
            ApiRoutes.SystemConfig.GetParameters(params)
        );

        return {
            type: params.type,
            data: response.data,
        };
    }
);

type State = {
    [key in SettingGroupType]?: SystemConfigParameterDto[];
};

const initialState: State = {};

const systemConfigsSlice = createSlice({
    name: "systemConfigs",
    initialState,
    reducers: {
        resetSettings: () => initialState,
    },
    extraReducers: (builder) => {
        builder.addCase(getSystemConfigs.fulfilled, (state, action) => {
            state[action.payload.type] = action.payload.data;
        });
    },
});

export const { resetSettings } = systemConfigsSlice.actions;

export default systemConfigsSlice.reducer;
